import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { area } from '@src/utils/area';

const ViewDetails = ({ confirmData, confirmDataHandle, languages }) => {
    const [active, setAcitve] = useState(false);

    useEffect(() => {
        if (!confirmData.isClosePopup) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.position = '';
        }

        if (confirmData.isClickOk) {
            setAcitve(true);
        } else {
            setAcitve(false);
        }
    }, [confirmData]);

    console.log(languages);

    return !confirmData.isClosePopup ? (
        <div className={styles.confirm}>
            <div className={styles.confirmBox}>
                <div className={styles.confirmTitle}>{area[languages].declaration.detailTitle}</div>
                <div className={styles.confirmContent}>
                    <div dangerouslySetInnerHTML={{ __html: area[languages].declaration.detailText }} />
                    <div className={styles.space_100} />
                </div>
                <div className={styles.confirmFix}>
                    <div className={styles.confirmFixTextBox}>
                        <div className={`${styles.confirmFixText} ${active ? styles.confirmActive : ''}`} dangerouslySetInnerHTML={{ __html: area[languages].declaration.promiseText }} />
                        <div className={styles.space_80} />
                        {!active && (
                            <div
                                className={languages === 'en' ? styles.confirmCopyButtonEn : styles.confirmCopyButtonZh}
                                onClick={() => {
                                    setAcitve(true);
                                }}>
                                {area[languages].declaration.copyText}
                            </div>
                        )}
                    </div>
                    <div className={styles.confirmOperate}>
                        <div
                            className={styles.confirmCancel}
                            onClick={() => {
                                confirmDataHandle({ isClickOk: false, isCheck: true, isClosePopup: true });
                            }}>
                            {area[languages].declaration.agreeText}
                        </div>
                        <div
                            className={`${styles.confirmYes} ${active ? styles.confirmActive : ''}`}
                            onClick={() => {
                                if (active) {
                                    confirmDataHandle({ isClickOk: true, isCheck: false, isClosePopup: true });
                                }
                            }}>
                            {area[languages].declaration.disagreeText}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) : null;
};

ViewDetails.propTypes = {
    confirmData: PropTypes.object,
    confirmDataHandle: PropTypes.func,
    languages: PropTypes.string,
};

export default errorBoundary(ViewDetails);
